<template>
    <div>
        <h2 class="titulo">DETALHES DO PLANO</h2>
        <h3 class="sub-titulo text-center">
            {{ pedido.plano.cd_plano_venda + " - " + pedido.plano.nome_plano }}
        </h3>
        <v-col class="detalhes-bem">
            <v-col>
                <img
                        :src="`${ws}/compra/imagembem/${pedido.bem.id_bem}`"
                        :alt="pedido.bem.nome_bem"
                        class="imagem-bem"
                />
            </v-col>
            <v-col>
                <div
                        class="float-right text-center d-flex flex-column"
                        style="height: 100%"
                >
                    <h3>{{ pedido.bem.nome_bem }}</h3>
                    <p class="mt-auto">Cód.: {{ pedido.bem.cd_bem }}</p>
                    <h4>{{ pedido.bem.valor_bem | money }}</h4>
                </div>
            </v-col>
        </v-col>
        <v-layout d-flex flex-column class="prazos">
            <p
                    :class="[
                        validate_fail ? 'validation-message' : 'subtitulo',
                        validade_animation ? 'balancar' : '',
                    ]"
            >
                Selecione uma opção abaixo: *
            </p>
            <span v-if="validate_fail" class="validation-message"
            >Campo obrigatório</span
            >
            <v-card class="d-flex" v-if="prazos_lineares.length > 0">
                <div class="variacao-parcela-wrapper">
                    <v-alert dense color="primary"> Linear </v-alert>
                </div>
                <v-flex>
                    <m-form ref="form_linear">
                        <v-row>
                            <v-col
                                    class="col-prazo-parcela"
                                    v-for="prazo in prazos_lineares"
                                    :key="`${prazo.id_plano_venda}|${prazo.pz_comercializacao}|LINEAR`"
                                    md="6"
                                    lg="4"
                                    cols="12"
                            >
                                <v-layout justify-space-between>
                                    <m-radio
                                            :rules="[$rules.required]"
                                            :id="`prazo_${prazo.pz_comercializacao}`"
                                            :comparador="plano_selecionado"
                                            :label="`${prazo.pz_comercializacao} meses`"
                                            :radio-value="prazo"
                                            v-model="pedido.plano"
                                            :tela-prazos="true"
                                    />
                                    <p
                                            class="valor-parcela mb-0"
                                            :style="{
                                                color:
                                                    pedido.plano === prazo
                                                        ? 'var(--dark)'
                                                        : 'var(--darkgray)',
                                            }"
                                    >
                                        Parcela:
                                        {{ prazo.vl_fisica | money }}
                                    </p>
                                </v-layout>
                            </v-col>
                        </v-row>
                    </m-form>
                </v-flex>
            </v-card>
            <v-card class="d-flex" v-if="prazos_degrau.length > 0">
                <div class="variacao-parcela-wrapper">
                    <v-alert dense color="primary"> Degrau </v-alert>
                </div>
                <v-flex>
                    <m-form ref="form_linear">
                        <v-row>
                            <v-col
                                    class="col-prazo-parcela"
                                    v-for="prazo in prazos_degrau"
                                    :key="`${prazo.id_plano_venda}|${prazo.pz_comercializacao}|DEGRAU`"
                                    md="6"
                                    lg="4"
                                    cols="12"
                            >
                                <v-layout justify-space-between>
                                    <m-radio
                                            :id="`prazo_${prazo.pz_comercializacao}`"
                                            :comparador="plano_selecionado"
                                            :label="`${prazo.pz_comercializacao} meses`"
                                            :radio-value="prazo"
                                            v-model="pedido.plano"
                                    />
                                    <p
                                            class="valor-parcela mb-0"
                                            :style="{
                                                color:
                                                    pedido.plano === prazo
                                                        ? 'var(--dark)'
                                                        : 'var(--darkgray)',
                                            }"
                                    >
                                        Parcela:
                                        {{ prazo.vl_fisica | money }}
                                    </p>
                                </v-layout>
                            </v-col>
                        </v-row>
                    </m-form>
                </v-flex>
            </v-card>
            <v-card class="d-flex" v-if="prazos_outros.length > 0">
                <div class="variacao-parcela-wrapper">
                    <v-alert dense color="primary"> Outros </v-alert>
                </div>
                <v-flex>
                    <m-form ref="form_linear">
                        <v-row>
                            <v-col
                                    class="col-prazo-parcela"
                                    v-for="prazo in prazos_outros"
                                    :key="`${prazo.id_plano_venda}|${prazo.pz_comercializacao}|OUTROS`"
                                    md="6"
                                    lg="4"
                                    cols="12"
                            >
                                <v-layout justify-space-between>
                                    <m-radio
                                            :id="`prazo_${prazo.pz_comercializacao}`"
                                            :comparador="plano_selecionado"
                                            :label="`${prazo.pz_comercializacao} meses`"
                                            :radio-value="prazo"
                                            v-model="pedido.plano"
                                    />
                                    <p
                                            class="valor-parcela mb-0"
                                            :style="{
                                                color:
                                                    pedido.plano === prazo
                                                        ? 'var(--dark)'
                                                        : 'var(--darkgray)',
                                            }"
                                    >
                                        Parcela:
                                        {{ prazo.vl_fisica | money }}
                                    </p>
                                </v-layout>
                            </v-col>
                        </v-row>
                    </m-form>
                </v-flex>
            </v-card>
        </v-layout>
        <v-btn text @click="voltar()" color="secondary" id="voltar">Voltar</v-btn>
        <v-btn
                :disabled="disable_avancar"
                color="primary"
                class="float-right"
                @click="avancar()"
                id="comprar"
        >
            Comprar
        </v-btn
        >
    </div>
</template>

<script>
  import MRadio from '@/components/MRadio'
  import { isNil } from 'lodash'
  import { mapState } from 'vuex'
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'
  import { notification } from '../../../plugins/helpers'

  export default {
    name: 'SelecionarPrazo',
    components: { MRadio },
    props: { value: Object },
    data: () => ({
      validate_fail: false,
      validade_animation: false,
      disable_avancar: true,
      id_plano_venda: 0,
      plano_selecionado: {
        nome_plano: '',
        id_plano_venda: 0,
        cd_plano_venda: '',
        id_taxa_plano: 0
      },
      pedido: {
        id_regiao_fiscal: null,
        id_tipo_venda: null,
        id_empresa: null,
        produto: {
          id_produto: 0
        },
        plano: {
          nome_plano: '',
          id_plano_venda: 0,
          cd_plano_venda: '',
          id_taxa_plano: 0,
          pz_comercializacao: 0,
          vl_fisica: 0
        },
        bem: {
          id_bem: 0,
          nome_bem: '',
          valor_bem: 0,
          cd_bem: ''
        }
      },
      prazos_lineares: [],
      prazos_degrau: [],
      prazos_outros: []
    }),
    computed: {
      ...mapState(['jornada_venda'])
    },
    watch: {
      pedido: {
        handler (val) {
          this.disable_avancar =
            isNil(val.plano) || val.plano.id_plano_venda <= 0
        },
        deep: true
      }
    },
    async mounted () {
      this.id_plano_venda = this.value.plano.id_plano_venda
      this.pedido = Object.assign({}, this.pedido, this.value)

      const prazos = await this.getPrazos()
      for (let mensagem of prazos.msgStack) {
        notification(mensagem.type, mensagem.message)
      }
      this.prazos_lineares = prazos.prazos_lineares
      this.prazos_degrau = prazos.prazos_degrau
      this.prazos_outros = prazos.prazos_outros

      if (this.prazos_lineares.length) {
        this.prazos_lineares.sort((a, b) =>
          a.pz_comercializacao > b.pz_comercializacao ? 1 : -1
        )
      }
      if (this.prazos_degrau.length) {
        this.prazos_degrau.sort((a, b) =>
          a.pz_comercializacao > b.pz_comercializacao ? 1 : -1
        )
      }
      if (this.prazos_outros.length) {
        this.prazos_outros.sort((a, b) =>
          a.pz_comercializacao > b.pz_comercializacao ? 1 : -1
        )
      }
    },

    methods: {
      voltar () {
        this.pedido.id_regiao_fiscal = null
        this.pedido.id_tipo_venda = null
        delete this.pedido.plano
        this.$emit('input', { ...this.pedido })
        this.$emit('prevPage')
      },
      avancar () {
        if (this.pedido.plano.id_taxa_plano) {
          this.sendAnalytics()
          this.$emit('input', { ...this.pedido })
          this.$emit('nextPage')
        } else {
          this.validade_animation = true
          this.validate_fail = true
          setTimeout(() => {
            this.validade_animation = false
          }, 500)
        }
      },
      sendAnalytics () {
        sendAnalyticsEvent(this.$gtag, 'produto_confirmado', {
          nome_bem: this.pedido.bem.nome_bem,
          cod_bem: this.pedido.bem.cd_bem,
          plano_venda: this.pedido.plano.nome_plano,
          valor_bem: this.pedido.bem.valor_bem,
          valor_parcela: this.pedido.plano.vl_fisica,
          qtd_parcelas: this.pedido.plano.pz_comercializacao,
          source_menu: this.jornada_venda
        })
      },
      async getPrazos () {
        let params = {
          id_bem: this.pedido.bem.id_bem,
          id_empresa: this.pedido.id_empresa,
          id_fabricante: this.pedido.bem.id_fabricante,
          id_produto: this.pedido.produto.id_produto,
          id_regiao_fiscal: this.pedido.id_regiao_fiscal,
          id_tipo_venda: this.pedido.id_tipo_venda,
          id_plano_venda: this.id_plano_venda,
          id_grupo: this.pedido.id_grupo,
          permite: this.$session.get('permite_venda_todos_produtos'),
          id_unidade_negocio: this.$session.get('id_unidade_negocio'),
          id_ponto_venda: this.$session.get('id_ponto_venda')
        }
        if (this.pedido.id_reserva) {
          params.id_reserva = this.pedido.id_reserva
          params.pz_comercializacao = this.pedido.pz_comercializacao
        }
        const ambientes = this.$session.get('ambiente')
        const unidadeCondicoesVenda = ambientes && ambientes.unidade_condicoes_venda
        if (unidadeCondicoesVenda) {
          params.unidade_condicoes_venda = unidadeCondicoesVenda
        }
        const res = await this.$http.get('/compra/prazos', { params })

        return res.data
      }
    }
  }
</script>

<style scoped lang="scss">
.detalhes-bem {
  margin-top: 20px;

  .col {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .imagem-bem {
    height: 120px;
    max-height: 120px;
    margin-bottom: 20px;
  }

  h3 {
    color: var(--primary);
    font-size: 1.7rem;
  }

  h4 {
    color: var(--secondary);
    font-size: 1.7rem;
  }

  p {
    color: var(--dark);
    font-size: 1.3rem;
    margin-bottom: 0;
  }
}

.prazos {
  margin-top: 40px;

  .subtitulo {
    text-align: center;
    color: var(--primary);
    margin-bottom: 0.15rem !important;
  }

  .v-card {
    padding: 15px;
    border-left: 1px solid var(--lightgray);
    border-right: 1px solid var(--lightgray);
    margin-bottom: 20px;
  }

  .variacao-parcela-wrapper {
    width: 120px;
    padding-right: 20px;
  }

  .v-alert {
    float: left;
    color: #ffffff;
    text-transform: uppercase;
    margin: 0;
    padding: 4px 12px;
  }

  .valor-parcela {
    margin-top: 12px;
  }

  .col-prazo-parcela:not(:nth-child(3n)) {
    border-right: 2px solid var(--gray);
  }

  .col-prazo-parcela:nth-child(1n + 4) {
    margin-top: 20px;
  }
}

.validation-message {
  text-align: center;
  color: var(--error);
  margin-bottom: 0.15rem !important;
}

@-webkit-keyframes balancar {
  from {
    margin-left: 10px;
  }

  to {
    margin-right: 10px;
  }
}

@keyframes balancar {
  from {
    margin-left: 6px;
  }

  to {
    margin-right: 6px;
  }
}

.balancar {
  -webkit-animation: balancar 0.09s alternate infinite ease-in-out;
  animation: balancar 0.09s alternate infinite ease-in-out;
}
</style>
